import { render, staticRenderFns } from "./StudentListRequest.vue?vue&type=template&id=b48c1f86&scoped=true"
import script from "./StudentListRequest.vue?vue&type=script&lang=js"
export * from "./StudentListRequest.vue?vue&type=script&lang=js"
import style0 from "./StudentListRequest.vue?vue&type=style&index=0&id=b48c1f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48c1f86",
  null
  
)

export default component.exports